import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const fmtDate = (iso) =>
  new Date(iso).toLocaleDateString("en-IN", { month: "short", year: "numeric" });

export const Reviews = () => {
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    fetch(`${API}/posts`)
      .then((r) => r.json())
      .then((d) => setArticles(d.slice(0, 3)))
      .catch(() => {});
  }, []);

  return (
  <section
    id="reviews"
    data-testid="reviews-section"
    className="mx-auto max-w-[1400px] px-6 py-28 md:px-12 md:py-40"
  >
    <Reveal>
      <p className="mb-6 text-xs font-semibold uppercase tracking-[0.25em] text-plum">
        06 · From Our Journal
      </p>
      <div className="flex flex-wrap items-end justify-between gap-8">
        <h2 className="max-w-2xl font-serif text-4xl leading-tight tracking-tight text-ink sm:text-5xl md:text-6xl">
          Reviews, field notes & <em className="text-plum">small convictions.</em>
        </h2>
        <Link
          to="/journal"
          data-testid="reviews-cta-all"
          className="group inline-flex items-center gap-2 rounded-full border border-ink/25 px-7 py-3.5 text-sm font-semibold text-ink transition-colors duration-300 hover:border-plum hover:text-plum"
        >
          Read Our Latest Book Reviews & Articles
          <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>
    </Reveal>

    <div className="mt-16 grid grid-cols-1 gap-x-8 gap-y-14 md:grid-cols-3">
      {articles.map((a, i) => (
        <Reveal key={a.id} delay={0.08 * i}>
          <Link to={`/journal/${a.slug}`} data-testid={`article-card-${a.slug}`} className="group block cursor-pointer border-t-2 border-ink/15 pt-6 transition-colors duration-300 hover:border-plum">
            <div className="flex items-center justify-between text-xs uppercase tracking-[0.2em]">
              <span className="font-semibold text-terracotta">{a.tag}</span>
              <span className="text-slate2">{fmtDate(a.published_at)}</span>
            </div>
            <h3 className="mt-5 font-serif text-2xl leading-snug text-ink transition-colors duration-300 group-hover:text-plum md:text-3xl">
              {a.title}
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-slate2 md:text-base">{a.excerpt}</p>
            <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-plum">
              Read article
              <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </Link>
        </Reveal>
      ))}
    </div>
  </section>
  );
};
